import { Heart } from "lucide-react";
import { Link } from "react-router";

import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { PROTECTED_ROUTES } from "@/constants/routes";

/**
 * Same navigation-gap fix as `ChatIcon`/`NotificationBell`: without this,
 * the `/wishlist` page and `ProductCard`'s favorite-toggle heart both
 * worked, but there was no way to actually navigate there from anywhere in
 * the app. No count badge, unlike those two — a saved-items total isn't an
 * "unread/new" signal demanding attention the way a message or notification
 * count is, and the exact count is one click away on the page itself.
 */
export function WishlistIcon() {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button type="button" variant="ghost" size="icon" aria-label="Wishlist" asChild>
          <Link to={PROTECTED_ROUTES.wishlist}>
            <Heart className="h-4 w-4" aria-hidden="true" />
          </Link>
        </Button>
      </TooltipTrigger>
      <TooltipContent>Wishlist</TooltipContent>
    </Tooltip>
  );
}
